module.exports = "//static.hsappstatic.net/salesImages/static-1.403/outlook/imgs/connect-inbox/inbox-types.png"